// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1_FAi","cls2":"CreateSocialItem-cls2_nmM CreateSocialItem-cls1_FAi"};